const yesNoLabels = {
  '1': 'Oui',
  '2': 'Non',
  '9': 'Non connu'
}

function getSeverity (code) {
  return (f) => {
    if (f.mainSeverity != null &&
        f.mainSeverity.code === code &&
        f.mainSeverity.value !== 999) {
      return f.mainSeverity.value
    }
    return null
  }
}

const sex = {
  field: 'sex',
  title: 'Sexe',
  labels: {
    '1': 'M', '2': 'F', '3': 'Aut.', '9': 'NC'
  }
}

const origin = {
  field: 'origin',
  title: 'Provenance',
  labels: {
    '0': 'DOM',
    '1': 'REA',
    '2': 'MCO',
    '3': 'SSR',
    '4': 'PSY',
    '5': 'SLD',
    '6': 'EHP',
    '7': 'AUT',
    '9': 'NC'
  }
}

const immuno = {
  field: 'immuno',
  title: 'Immunodépression',
  labels: {
    '1': 'Apl. < 500 PN',
    '2': 'Autre immuno.',
    '3': 'Non immuno.',
    '9': 'Non connu'
  }
}

const birthWeight = {
  field: 'birthWeight',
  title: 'Poids de naissance',
  type: 'mean',
  unit: 'g',
  fixed: 0
}

const gestationalAge = {
  field: 'gestationalAge',
  title: 'Âge gestationnel',
  type: 'mean',
  unit: 'SA',
  fixed: 0
}

const future = {
  field: 'future',
  title: 'Devenir du patient à 7 jours',
  labels: {
    '1': 'Vivant',
    '2': 'Décédé',
    '9': 'Non connu'
  }
}

const trauma = {
  field: 'trauma',
  title: 'Patient traumatisé',
  labels: yesNoLabels
}

const catDiag = {
  field: 'diagnosis',
  title: 'Catégorie diagnostique',
  labels: {
    '1': 'Médicale',
    '2': 'Chir. urgente',
    '3': 'Chir. réglée',
    '9': 'Non connu'
  }
}

const antibio = {
  field: 'antibio',
  title: `Antibiotique à l'admission`,
  labels: yesNoLabels
}

const igsII = {
  field: getSeverity('igsII'),
  title: 'Score de sévérité IGSII',
  type: 'mean',
  fixed: 2
}

const pimII = {
  field: getSeverity('pimII'),
  title: 'Score de sévérité PIMII',
  type: 'mean',
  fixed: 2
}

const cribII = {
  field: getSeverity('cribII'),
  title: 'Score de sévérité CRIBII',
  type: 'mean',
  fixed: 2
}

const dead = {
  field: 'dead',
  title: 'Décès',
  labels: yesNoLabels
}

const portage = {
  field: 'portageBmrBhre',
  title: 'Portage BMR/BHRe',
  labels: yesNoLabels
}
const portageMO = {
  field: 'bmrBhreMicroOrg',
  title: 'Micro-organismes BMR/BHRe',
  labels: {
    '0': 'SARM',
    '1': 'GISA',
    '2': 'ERG',
    '3': 'EBLSE',
    '4': 'EPC',
    '5': 'ABRI',
    '6': 'PARC'
  }
}

const ecmo = {
  field: 'ecmo',
  title: 'ECMO',
  labels: {
    '1': 'Veino-artérielle',
    '2': 'Voie veino-veineuse',
    '3': 'Non',
    '9': 'Non Connu'
  }
}

const intubated = {
  field: 'intubated',
  title: 'Intubation',
  labels: yesNoLabels
}

const urinary = {
  field: 'urinary',
  title: 'Sondage urinaire',
  labels: yesNoLabels
}

const birthSite = {
  field: 'birthSite',
  title: 'Lieu de naissance',
  labels: {
    '1': `Dans l'établissement`,
    '2': `Hors de l'établissement`,
    '9': 'Non connu'
  }
}

const neoOrigin = {
  field: 'origin',
  title: 'Provenance',
  labels: {
    '0': 'DOM - Domicile',
    '1': 'NN - Service de Néonatalogie',
    '2': 'MATER - Unité de maternité',
    '3': 'SAL - Salle de naissance',
    '4': 'BO - Bloc obstétrical',
    '5': 'AUTSER - Autre service',
    '6': 'AUTETAB - Autre établissement',
    '7': 'AUT - Autre',
    '9': 'NC - Non connu'
  }
}

const leucomalacy = {
  field: 'leucomalacy',
  title: 'Leucomalacie',
  labels: yesNoLabels
}

const neoFuture = {
  field: 'future',
  title: 'Devenir',
  labels: {
    '0': `DOM - Domicile`,
    '1': `ETAB - Autre service de l'établissement`,
    '2': `AUTETAB - Autre établissement`,
    '9': `NC - Non connu`
  }
}

const reaBactKT = {
  field: (f) => {
    const result = []
    f.catheters.forEach(
      c => {
        result.push(c.type)
      }
    )
    return result
  },

  title: 'Type de cathéter',
  labels: {
    '1': 'CVC',
    '2': 'CCI',
    '3': 'CVO',
    '4': 'PICC line',
    '5': 'Cathéter dialyse',
    '6': 'Autre',
    '9': 'Non connu'
  }
}

export default {
  bactADI: [
    sex,
    origin,
    immuno,
    birthWeight,
    gestationalAge,
    future
  ],

  reaBactADI: [
    sex,
    origin,
    trauma,
    catDiag,
    antibio,
    immuno,
    igsII,
    pimII,
    cribII,
    birthWeight,
    gestationalAge,
    reaBactKT,
    dead
  ],

  reaInfADI: [
    sex,
    origin,
    trauma,
    catDiag,
    immuno,
    antibio,
    igsII,
    pimII,
    portage,
    portageMO,
    ecmo,
    intubated,
    urinary,
    dead
  ],

  diaInfADI: [
    sex
  ],

  neoInfADI: [
    sex,
    birthSite,
    neoOrigin,
    cribII,
    birthWeight,
    gestationalAge,
    leucomalacy,
    dead,
    neoFuture
  ]
}
